var _excluded = ["value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { components } from 'react-select';
import styled, { css } from 'styled-components';
import { classes } from "../constants.js";
/* Inline input when using creatable multi value props. */
/* react-select uses a complex combination of flex and grid in different states.
This wrapper creates a necessary nesting order and grid styles for layout. */
var StyledDiv = styled.div.withConfig({
  componentId: "CL__sc-1cfv8uo-0"
})(["display:inline-grid;grid-area:1/1/2/3;grid-template-columns:0 minmax(0,min-content);overflow:hidden;"]);

/* Note: this includes a div. We show the typed value in a badge/pill as the
user types, however when the user hasn't typed anything, we hide the
badge/pill's background because it will just look like a little boop of color
without any text in it (all the time). */
var StyledComponentsInput = styled(components.Input).withConfig({
  componentId: "CL__sc-1cfv8uo-1"
})(["", ""], _ref => {
  var {
    $hasValue
  } = _ref;
  return !$hasValue && css(["&&&{background-color:transparent;padding-left:0;}"]);
});
var CreatableMultiValueInput = _ref2 => {
  var _value$toString$lengt;
  var {
      value
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledDiv, null, /*#__PURE__*/React.createElement(StyledComponentsInput, _extends({
    $hasValue: !!value && (typeof value === 'string' || typeof value === 'number' || typeof value === 'object') && ((_value$toString$lengt = value === null || value === void 0 ? void 0 : value.toString().length) !== null && _value$toString$lengt !== void 0 ? _value$toString$lengt : 0) > 0,
    className: "".concat(classes.badge.slice(1), " ").concat(classes.badgeText.slice(1)),
    value: value
  }, props)));
};
export default CreatableMultiValueInput;